import { Color } from '@diritto/common/style/color';

export const ThreeDots = ({ className, color = Color.Gray700 }: { color?: string; className?: string }) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.33333 11.3334C6.06971 11.3334 6.66667 10.7365 6.66667 10.0001C6.66667 9.2637 6.06971 8.66675 5.33333 8.66675C4.59695 8.66675 4 9.2637 4 10.0001C4 10.7365 4.59695 11.3334 5.33333 11.3334Z"
      fill={color}
    />
    <path
      d="M11.3333 10.0001C11.3333 10.7365 10.7364 11.3334 10 11.3334C9.26362 11.3334 8.66667 10.7365 8.66667 10.0001C8.66667 9.2637 9.26362 8.66675 10 8.66675C10.7364 8.66675 11.3333 9.2637 11.3333 10.0001Z"
      fill={color}
    />
    <path
      d="M16 10.0001C16 10.7365 15.403 11.3334 14.6667 11.3334C13.9303 11.3334 13.3333 10.7365 13.3333 10.0001C13.3333 9.2637 13.9303 8.66675 14.6667 8.66675C15.403 8.66675 16 9.2637 16 10.0001Z"
      fill={color}
    />
  </svg>
);
